<template>
    <div class="game-instance-list init">
        <div class="cps-page-top">
            <div class="jc-page-header">
                <el-page-header show-back-icon :title="$t('game.list.gameServerGuide')" @back="goBack" />
            </div>
            <div class="jc-page-content">
                <section class="remote-connection">
                    <section class="methods w40">
                        <h3 class="methods-title">
                            <span class="methods-title-icon windows-icon"></span>
                            <span class="methods-title-connect ml10">{{ $t('game.list.windowsConnect') }}</span>
                        </h3>
                        <section class="methods-content mt15">
                            <div class="methods-content-item">
                                <h3 class="title">
                                    <span class="label">{{ $t('game.list.windowsConnectContent.method1') | withColon
                                    }}</span>
                                    <span class="field">点击<span class="text">"一键下载文件"</span>，保存文件到Windows
                                        本地，双击保存的文件或者右键打开文件，即可连接游戏服务器。</span>
                                </h3>
                            </div>
                            <div class="methods-content-item mt15">
                                <h3 class="title">
                                    <span class="label">{{ $t('game.list.windowsConnectContent.method2') | withColon
                                    }}</span>
                                    <span class="field">{{
                                        $t('game.list.windowsConnectContent.method2Field') }}</span>
                                </h3>
                                <div class="content">
                                    <p class="content-item">
                                        <span class="content-item-icon icon1"></span>
                                        <span>在Windows中找到并运行“远程桌面连接”(可以在工具栏搜索框中搜索或者在开始菜单
                                            “Windows附件”中找到或者输入mstsc远程桌面连接命令按回车键)</span>
                                    </p>
                                    <p class="content-item">
                                        <span class="content-item-icon icon2"></span>
                                        <span>在“计算机”输入框中输入游戏服务器的“公网 IP”</span>
                                    </p>
                                    <p class="content-item">
                                        <span class="content-item-icon icon3"></span>
                                        <span>在“用户账户”输入框中输入“administrator”</span>
                                    </p>
                                    <p class="content-item">
                                        <span class="content-item-icon icon4"></span>
                                        <span>点击连接，在弹出框中输入之前购买游戏服务器设置的“密码”</span>
                                    </p>
                                    <p class="content-item mt10">
                                        <span>如果连接成功，会弹出“证书”弹框，选择“同意”，即可看到Windows桌面</span>
                                    </p>
                                </div>
                            </div>
                        </section>
                    </section>
                    <section class="methods w40">
                        <h3 class="methods-title">
                            <span class="methods-title-icon mac-icon"></span>
                            <span class="methods-title-connect ml10">{{ $t('game.list.macConnect') }}</span>
                        </h3>
                        <h3 class="tips mt10"><span>前提：Mac电脑安装好Windows远程桌面软件，比如Microsoft Remote Desktop</span>
                        </h3>
                        <section class="methods-content mt15">
                            <div class="methods-content-item">
                                <h3 class="title">
                                    <span class="label">{{ $t('game.list.windowsConnectContent.method1') | withColon
                                    }}</span>
                                    <span class="field">点击<span class="text">"一键下载文件"</span>，保存文件到Mac
                                        本地，双击保存的文件,即可连接游戏服务器。</span>
                                </h3>
                            </div>
                            <div class="methods-content-item mt15">
                                <h3 class="title">
                                    <span class="label">{{ $t('game.list.windowsConnectContent.method2') | withColon
                                    }}</span>
                                    <span class="field">{{
                                        $t('game.list.windowsConnectContent.method2Field') }}</span>
                                </h3>
                                <div class="content">
                                    <p class="content-item">
                                        <span class="content-item-icon icon1"></span>
                                        <span>运行Mac电脑预先安装的Windows远程桌面软件(比如Microsoft Remote Desktop)，添加PC/ 连接</span>
                                    </p>
                                    <p class="content-item">
                                        <span class="content-item-icon icon2"></span>
                                        <span>在“PC名称”输入框中输入游戏服务器的“公网IP”</span>
                                    </p>
                                    <p class="content-item">
                                        <span class="content-item-icon icon3"></span>
                                        <span>在“用户账户”输入框中输入“administrator”</span>
                                    </p>
                                    <p class="content-item">
                                        <span class="content-item-icon icon4"></span>
                                        <span>点击连接，在弹出框中输入之前购买游戏服务器设置的“密码”</span>
                                    </p>
                                    <p class="content-item mt10">
                                        <span>如果连接成功，会弹出“证书”弹框，选择“同意”，即可看到Windows桌面</span>
                                    </p>
                                </div>
                            </div>
                        </section>
                    </section>
                    <section class="methods w17">
                        <h3 class="methods-title">
                            <span class="methods-title-icon others-icon"></span>
                            <span class="methods-title-connect ml10">{{ $t('game.list.otherConnect') }}</span>
                        </h3>
                        <h3 class="tips mt10">
                            <span>可以自行安装支持RDP协议的远程桌面软件，创建“新连接”，输入地址(公网IP)，输入用户名(administrator)，输入密码(购买时设置)，即可连接游戏服务器。</span>
                        </h3>
                    </section>
                </section>
                <section class="steam mt15">
                    <section class="steam-guide w38">
                        <h3 class="methods-title">
                            <span class="methods-title-icon steam-icon"></span>
                            <span class="methods-title-connect ml10">{{ $t('game.list.steamGuideTitle') }}</span>
                        </h3>
                        <div class="steam-guide-tips mt10 pr20">
                            <h3 class="title">{{ $t('game.list.steamGuideTips.setSteam') }}</h3>
                            <div class="content mt10">
                                <p class="content-item">
                                    <span class="content-item-icon icon1"></span>
                                    <span>通过“远程连接”（Windows连接/Mac连接）进入PC游戏服务器，双击Accout脚本，取消勾选“要使用本计算机必须输入用户名密码”，点击应用输入游戏服务器密码，点击确认。</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon2"></span>
                                    <span>开启PC游戏服务器上的Steam客户端，登录自己的Steam账号（如果没有Steam账号请参考“<a
                                            href="https://docs.jdcloud.com/cn/cloud-physical-server/steam"
                                            target="_blank">如何注册Steam账号并购买游戏</a>”教程），选择顶部导航到“库”，并点击左侧的黑悟空游戏</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon3"></span>
                                    <span>切换到本地电脑，开启Steam客户端，登录自己的Steam账号，选择顶部导航到“库”，并点击左侧的黑悟空游戏，点击右侧“流式传输”按钮，稍等随后会弹出“授权码”</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon4"></span>
                                    <span>切换到PC游戏服务器上的Steam客户端，将刚刚本地电脑上弹出的“授权码”输入进行绑定，确认绑定成功（如果不成功，请重复③④步骤）</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon5"></span>
                                    <span>绑定成功后，直接在PC游戏服务器内选择“重启”，此时远程连接会断开。注意：重启PC游戏服务器之后，一定暂时不要再远程连接PC游戏服务器，否则会导致Steam串流游玩失败（如果需要调整其他设置，可远程连接进行设置，但设置完毕后记得再次“重启”PC游戏服务器）</span>
                                </p>
                            </div>
                        </div>
                    </section>
                    <section class="steam-guide pl20 pr20 w42">
                        <div class="steam-guide-tips">
                            <h3 class="title">{{ $t('game.list.steamGuideTips.streamGames') }}</h3>
                            <div class="desc mt10">
                                在完成上述“设置Steam”操作后，请在本地电脑Steam客户端等待串流初始化，此过程大概等待3-5分钟，这个过程本地客户端“黑悟空游戏”的按钮会出现状态变化，具体变化过程如下：
                            </div>
                            <div class="content mt5">
                                <p class="content-item">
                                    <span class="content-item-icon icon1"></span>
                                    <span>按钮显示“流式传输”，无须点击，请继续等待</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon2"></span>
                                    <span>按钮显示“安装”，不要点击，请继续等待（因为我们是串流模式游玩，因此不需要本地安装游戏，如果本地已经安装，此时会显示“开始游戏”）</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon3"></span>
                                    <span>按钮显示“流式传输”，双击按钮，此时会弹出提示窗让选择启动选项，直接点击下放的“开始游戏”，此时远端PC游戏服务器开始启动黑悟空游戏，大概3-5分钟，请继续等待</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon4"></span>
                                    <span>按钮显示“连接”，双击按钮，此时本地电脑会加载Steam串流客户端，并在本地电脑主屏进入串流游玩界面，请稍作等待</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon5"></span>
                                    <span>在本地电脑主屏的串流客户端游戏界面，等待黑悟空游戏加载完毕，即可畅玩。</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon6"></span>
                                    <span>若需要中途退出游戏，可通过快捷键“windows键+tab键”切换到本地Steam页面，点击”停止“按钮；如果在串流中退出游戏，下次进入游戏只需要重复③④⑤即可</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon7"></span>
                                    <span>若通过中途“停止”按钮关闭游戏，下次要重新连接，点击“连接”按钮即可</span>
                                </p>
                            </div>
                        </div>
                    </section>
                    <section class="steam-guide pl20 w18">
                        <div class="steam-guide-tips ">
                            <h3 class="title">{{ $t('game.list.steamGuideTips.exceptionHandling') }}</h3>
                            <div class="content mt10">
                                <p class="content-item">
                                    <span class="content-item-icon icon1"></span>
                                    <span>任何时候，通过远程连接PC游戏服务器进行设置调整后，需要重启PC游戏服务器后才能进行串流</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon2"></span>
                                    <span>在进行“串流玩游戏”时，如果在③④步出现闪退，那么请重启PC游戏服务器</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon3"></span>
                                    <span>在进行“串流玩游戏”时，如果在③④步出现弹窗提示“流失传输启动失败”，那么请检查本地路由器的安全策略，建议全部关闭后再重试，如果多次失败后还是出现“流失传输启动失败”，请使用ToDesk模式畅玩。</span>
                                </p>
                            </div>
                        </div>
                    </section>
                </section>
                <section class="desk mt15">
                    <section class="steam-guide w38">
                        <h3 class="methods-title">
                            <span class="methods-title-icon desk-icon"></span>
                            <span class="methods-title-connect ml10">{{ $t('game.list.deskGuideTitle') }}</span>
                        </h3>
                        <div class="steam-guide-tips mt10 pr20">
                            <h3 class="title">{{ $t('game.list.deskGuideTips.setSteam') }}</h3>
                            <div class="content mt10 w410">
                                <p class="content-item">
                                    <span class="content-item-icon icon1"></span>
                                    <span>通过“远程连接”（Windows连接/Mac连接）进入PC游戏服务器</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon2"></span>
                                    <span>开启PC游戏服务器上的ToDesk客户端，登录自己的ToDesk账号（如果没有ToDesk账号请参考“<a
                                            href="https://docs.jdcloud.com/cn/cloud-physical-server/todesk"
                                            target="_blank">如何注册ToDesk账号并升级成游戏版</a>”教程）</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon3"></span>
                                    <span>记录PC游戏服务器的“设备代码”和“临时密码”，如果不想使用临时密码，可以点击临时密码旁边的“按钮”，在弹出框内设置“安全密码”</span>
                                </p>
                            </div>
                        </div>
                    </section>
                    <section class="steam-guide pl20 pr20 w42">
                        <div class="steam-guide-tips">
                            <h3 class="title">{{ $t('game.list.deskGuideTips.streamGames') }}</h3>
                            <div class="desc mt10">在完成上述“ToDesk设置”操作后，切换到本地电脑</div>
                            <div class="content mt5">
                                <p class="content-item">
                                    <span class="content-item-icon icon1"></span>
                                    <span>开启本地电脑ToDesk客户端，登录自己的ToDesk账号</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon2"></span>
                                    <span>在“远程控制设备”输入框内输入PC游戏服务器上ToDesk客户端显示的“设备代码”，点击“连接”按钮</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon3"></span>
                                    <span>在弹出的输入框中输入PC游戏服务器上ToDesk客户端显示的“临时密码”（如果关闭临时密码，则输入自己设置的“安全密码”）</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon4"></span>
                                    <span>连接成功，ToDesk显示PC游戏服务器桌面，此时可以关闭“Windows或者Mac电脑的远程连接，后续都是用ToDesk操作即可”</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon5"></span>
                                    <span>使用ToDesk显示的PC游戏服务器桌面，像操作本地电脑一样操作PC游戏服务器，开启黑悟空游玩即可。</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon6"></span>
                                    <span>游玩完毕或者中途休息，可以退出ToDesk远程连接，后续继续游玩直接重复②③即可。</span>
                                </p>
                                <p class="content-item">
                                    <span class="content-item-icon icon7"></span>
                                    <span>若通过中途“停止”按钮关闭游戏，下次要重新连接，点击“连接”按钮即可</span>
                                </p>
                            </div>
                        </div>
                    </section>
                    <section class="steam-guide pl20 w18">
                        <div class="steam-guide-tips ">
                            <h3 class="title">{{ $t('game.list.deskGuideTips.exceptionHandling') }}</h3>
                            <div class="desc mt10">ToDesk游戏版专门针对游戏优化，建议参考图文教程进行设置，已获得更好的游戏体验。</div>
                        </div>
                    </section>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GameInstanceList',
    mixins: [],
    components: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {


    },

    watch: {

    },
    methods: {
        goBack() {
            this.$router.push({
                path: '/instance/game/list'
            });
        },
    }

};
</script>

<style lang="scss">
@import '../../../assets/scss/listComon';

@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/gameInstance/guide/Index.vue